import React from 'react';
import FinanceTooltipPanel from '../../../financeShared/FinanceTooltipPanel';

const TooltipStatus = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const linhas = [
      { id: 'vencidas', label: 'Vencidas', valor: Number(data.vencidas) || 0, cor: 'var(--status-bad, #EF4444)', text: 'text-[color:var(--status-bad,var(--text-primary))]' },
      { id: 'proximas', label: 'Próximas ao vencimento', valor: Number(data.proximasVencimento) || 0, cor: 'var(--status-warn, #F59E0B)', text: 'text-[color:var(--status-warn,var(--text-primary))]' },
      { id: 'hoje', label: 'Vencem hoje', valor: Number(data.hoje) || 0, cor: '#FBBF24', text: 'text-yellow-300' },
      { id: 'pagas', label: 'Pagas', valor: Number(data.pagas) || 0, cor: 'var(--status-good, #10B981)', text: 'text-[color:var(--status-good,var(--text-primary))]' },
      { id: 'parcial', label: 'Parcialmente pagas', valor: Number(data.pagasParcialmente) || 0, cor: 'var(--status-good, #10B981)', text: 'text-[color:var(--status-good,var(--text-primary))]' },
      { id: 'aberto', label: 'Em aberto', valor: Number(data.emAberto) || 0, cor: 'var(--chart-1, #3B82F6)', text: 'text-[color:var(--chart-1,var(--text-primary))]' },
      { id: 'canceladas', label: 'Canceladas', valor: Number(data.canceladas) || 0, cor: 'var(--text-muted, #6B7280)', text: 'text-[color:var(--text-muted)]' },
    ].filter((item) => item.valor > 0);

    const totalContas = Number(data.totalContas) || linhas.reduce((sum, item) => sum + item.valor, 0);
    const rows = linhas.map((linha) => ({
      id: linha.id,
      label: linha.label,
      dotColor: linha.cor,
      textClass: linha.text,
      value: `${linha.valor} conta${linha.valor !== 1 ? 's' : ''}`,
    }));
    
    return (
      <FinanceTooltipPanel
        title={data.nomeCompleto || label}
        rows={rows}
        totalText={`Total: ${totalContas} conta${totalContas !== 1 ? 's' : ''} nesta conta bancária`}
        emptyText="Sem status contabilizados."
      />
    );
  }
  return null;
};

export default TooltipStatus;


